import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/feature/PageMeta';
import Breadcrumb from '@/components/base/Breadcrumb';

const reviews = [
  { name: '漫画控小王', rating: 5, content: '洞洞杂货铺真的是我见过最好的免费漫画网站！画质清晰、更新速度快，而且完全没有广告弹窗，体验太棒了。追了《仙界快递员》快一年了，每次更新都第一时间来看~', date: '2026-07-28' },
  { name: '夜猫子读者', rating: 5, content: '作为一个每天熬夜看漫画的人，洞洞杂货铺简直是救星。分类做得很好，找漫画特别方便。最重要的是全免费！强烈推荐给所有漫画爱好者。', date: '2026-07-25' },
  { name: '二次元少女', rating: 5, content: '《青梅小调》完结的时候哭死我了！感谢洞洞杂货铺让我看到这么美好的故事。网站界面也很清爽，手机上看也特别流畅。已经安利给身边所有朋友了。', date: '2026-07-20' },
  { name: '追漫达人阿杰', rating: 4, content: '漫画资源非常丰富，从热血到恋爱、从悬疑到古风，各种类型都有。更新也很快，基本和官方同步。如果能增加一个收藏夹功能就更完美了！', date: '2026-07-18' },
  { name: '书虫小美', rating: 5, content: '在洞洞杂货铺看了大半年的漫画了，从来没有让我失望过。内容质量高，翻译也很到位。最让我惊喜的是《深渊之下》，那种紧张刺激的氛围渲染得太好了！', date: '2026-07-15' },
  { name: '上班摸鱼族', rating: 5, content: '午休时间必逛洞洞杂货铺！《办公室物语》简直就是我的职场生存指南，每话都笑到肚子痛。网站加载速度很快，公司网络也能流畅看。满分推荐！', date: '2026-07-10' },
];

const faqs = [
  { question: '洞洞杂货铺的漫画都是免费的吗？', answer: '是的！洞洞杂货铺所有漫画均免费阅读，无需付费或订阅会员。我们坚持为漫画爱好者提供优质的免费阅读体验，让大家畅享漫画的乐趣。' },
  { question: '漫画更新频率是怎样的？', answer: '我们与各大漫画平台保持同步更新，热门漫画通常每周更新1-2话。您可以在网站首页的"最新更新"板块查看最近的更新动态。' },
  { question: '支持手机阅读吗？', answer: '完全支持！洞洞杂货铺采用响应式设计，完美适配手机、平板和电脑等各种设备。无论在什么设备上阅读，都能获得流畅舒适的体验。' },
  { question: '如何找到我想看的漫画？', answer: '您可以通过首页的分类导航浏览不同类型的漫画，也可以在导航栏的搜索框中直接搜索您想看的漫画名称。我们会持续优化搜索功能，帮助您更快找到心仪的作品。' },
  { question: '漫画内容有版权问题吗？', answer: '洞洞杂货铺严格遵守版权法规，所有内容均来自正版授权渠道。如您发现任何版权问题，请通过联系我们页面与我们沟通，我们将第一时间处理。' },
];

function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      return;
    }
    try {
      const body = new URLSearchParams();
      body.append('name', formData.get('name') as string);
      body.append('email', formData.get('email') as string);
      body.append('message', formData.get('message') as string);
      const res = await fetch('https://readdy.ai/api/form/d9p0eiaftmtnfcfh0f90', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      const text = await res.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { parsed = null; }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
        setErrorMsg(parsed?.meta?.message || parsed?.message || '发送失败，请稍后再试');
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请稍后再试');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4" data-readdy-form="">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1">姓名</label>
          <input type="text" id="contact-name" name="name" required className="w-full text-sm bg-background-50 border border-background-200 rounded-lg px-4 py-2.5 focus:outline-none focus:border-primary-300 transition-colors text-foreground-700" placeholder="请输入您的姓名" />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1">邮箱</label>
          <input type="email" id="contact-email" name="email" required className="w-full text-sm bg-background-50 border border-background-200 rounded-lg px-4 py-2.5 focus:outline-none focus:border-primary-300 transition-colors text-foreground-700" placeholder="请输入您的邮箱" />
        </div>
      </div>
      <div>
        <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1">留言内容</label>
        <textarea id="contact-message" name="message" required maxLength={500} rows={4} className="w-full text-sm bg-background-50 border border-background-200 rounded-lg px-4 py-2.5 focus:outline-none focus:border-primary-300 transition-colors text-foreground-700 resize-none" placeholder="请输入您想说的内容（最多500字）" />
        <p className="text-xs text-foreground-400 mt-1">最多500字</p>
      </div>
      <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="form-honeypot" />
      {status === 'success' ? (
        <p className="text-sm text-accent-600 font-medium">发送成功！感谢您的留言，我们会尽快回复~</p>
      ) : (
        <button type="submit" disabled={status === 'loading'} className="bg-primary-500 text-white px-8 py-2.5 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer disabled:opacity-50">
          {status === 'loading' ? '发送中...' : '发送留言'}
        </button>
      )}
      {status === 'error' && <p className="text-xs text-red-500">{errorMsg}</p>}
    </form>
  );
}

export default function AboutPage() {
  const breadcrumbLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.dongdongcomic.com/' },
      { '@type': 'ListItem', position: 2, name: '关于我们' },
    ],
  };

  const aboutLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于洞洞杂货铺漫画',
    url: 'https://www.dongdongcomic.com/about',
    description: '洞洞杂货铺漫画品牌介绍，了解我们的故事、用户口碑与联系方式。',
    isPartOf: { '@type': 'WebSite', name: '洞洞杂货铺漫画', url: 'https://www.dongdongcomic.com' },
  };

  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <PageMeta
        title="关于我们-洞洞杂货铺漫画-品牌介绍与联系方式"
        description="了解洞洞杂货铺漫画的品牌故事、用户口碑评价与联系方式。洞洞杂货铺致力于为漫画爱好者提供优质的免费阅读体验。"
        keywords="洞洞杂货铺,关于我们,品牌介绍,联系方式,漫画平台"
        canonicalUrl="https://www.dongdongcomic.com/about"
        jsonLd={[breadcrumbLd, aboutLd, faqLd]}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-12">
          <div className="px-4 md:px-6 max-w-[1000px] mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />

            <section id="story" className="mb-16">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-6">关于洞洞杂货铺</h1>
              <div className="bg-background-100 rounded-xl p-6 md:p-10">
                <div className="flex flex-col md:flex-row gap-8 items-start">
                  <div className="flex-1">
                    <h2 className="text-xl font-bold text-foreground-900 mb-4">我们的品牌故事</h2>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                      洞洞杂货铺诞生于2024年，由一群热爱漫画的年轻人共同创立。我们深信每一部漫画都是一扇通往不同世界的门——就像一间神奇的杂货铺，里面藏着无数精彩的故事等待被发现。
                    </p>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                      品牌名"洞洞"寓意着透过小小的洞口窥见广阔的世界。我们希望为每一位漫画爱好者提供一个温暖、便捷的阅读空间，让大家无需付费就能畅享最优质的漫画内容。
                    </p>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      作为土豪漫画网旗下的核心平台，洞洞杂货铺始终坚持"免费阅读、品质至上"的理念，目前已收录超过500部漫画作品，涵盖热血、恋爱、搞笑、悬疑、奇幻、都市、古风、科幻等多元类型，累计服务超过<strong>2000万</strong>漫画读者。
                    </p>
                  </div>
                  <div className="w-full md:w-[280px] flex-shrink-0 aspect-square rounded-xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=A%20warm%20and%20cozy%20Chinese%20style%20illustration%20of%20a%20small%20shop%20interior%20with%20bookshelves%20filled%20with%20colorful%20manga%20books%2C%20warm%20yellow%20lighting%2C%20cozy%20reading%20corner%20with%20cushions%2C%20plants%2C%20watercolor%20texture%2C%20inviting%20atmosphere%2C%20clean%20simple%20composition&width=600&height=600&seq=about-brand-01&orientation=squarish"
                      alt="洞洞杂货铺品牌形象"
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </section>

            <section id="reviews" className="mb-16">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">用户口碑</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {reviews.map((review, index) => (
                  <div key={index} className="bg-background-100 rounded-xl p-5">
                    <div className="flex items-center gap-1 mb-2">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`text-sm ${i < review.rating ? 'ri-star-fill text-amber-400' : 'ri-star-line text-foreground-300'}`}
                        ></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-3">{review.content}</p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <span className="font-medium text-foreground-700">{review.name}</span>
                      <span>{review.date}</span>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section id="faq" className="mb-16">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">常见问题</h2>
              <div className="space-y-3">
                {faqs.map((faq, index) => (
                  <details key={index} className="bg-background-100 rounded-xl group">
                    <summary className="px-6 py-4 cursor-pointer list-none flex items-center justify-between text-sm font-medium text-foreground-800">
                      {faq.question}
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200"></i>
                    </summary>
                    <div className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </div>
                  </details>
                ))}
              </div>
            </section>

            <section id="contact">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">联系我们</h2>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="bg-background-100 rounded-xl p-6 md:p-8">
                  <h3 className="text-lg font-bold text-foreground-900 mb-6">发送留言</h3>
                  <ContactForm />
                </div>
                <div className="bg-background-100 rounded-xl p-6 md:p-8">
                  <h3 className="text-lg font-bold text-foreground-900 mb-6">联系方式</h3>
                  <div className="space-y-5">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                        <i className="ri-mail-line text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-800">电子邮箱</p>
                        <p className="text-sm text-foreground-500">contact@dongdongcomic.com</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 flex-shrink-0">
                        <i className="ri-wechat-line text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-800">微信公众号</p>
                        <p className="text-sm text-foreground-500">洞洞杂货铺漫画</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 flex-shrink-0">
                        <i className="ri-bilibili-line text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-800">B站官方号</p>
                        <p className="text-sm text-foreground-500">洞洞杂货铺官方</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                        <i className="ri-time-line text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-800">工作时间</p>
                        <p className="text-sm text-foreground-500">周一至周五 9:00 - 18:00</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section id="copyright" className="mt-16 bg-background-100 rounded-xl p-6">
              <h3 className="text-sm font-bold text-foreground-800 mb-2">版权声明</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                洞洞杂货铺所有漫画内容均来自正版授权渠道，版权归原作者及版权方所有。本站仅提供在线阅读服务，不对任何内容进行修改、复制或分发。如您发现本站存在侵权内容，请通过联系方式与我们沟通，我们将在核实后第一时间处理。感谢您的理解与支持。
              </p>
            </section>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}